import React from "react";
import { Helmet } from 'react-helmet-async';

const TradeLawPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>特定商取引法に基づく表記 | オリパサイト作成サービス JOYBASE</title>
        <meta name="description" content="JOYBASEの特定商取引法に基づく表記です。オリパサイト作成SaaSサービスJOYBASEの運営会社情報、支払い方法、キャンセルポリシーなどを掲載しています。" />
        <meta property="og:title" content="特定商取引法に基づく表記 | オリパサイト作成サービス JOYBASE" />
        <meta property="og:description" content="JOYBASEの特定商取引法に基づく表記です。オリパサイト作成SaaSサービスJOYBASEの運営会社情報、支払い方法、キャンセルポリシーなどを掲載しています。" />
        <link rel="canonical" href="https://www.joybase.jp/trade-law" />
        <meta property="og:url" content="https://www.joybase.jp/trade-law" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <html lang="ja" />
      </Helmet>
      <section className="bg-white">
        <div className="mx-auto max-w-screen-xl px-4 pt-24 pb-8 sm:px-6 sm:pt-28 sm:pb-12 lg:px-8 lg:pt-32 lg:pb-16 flex items-center justify-center">
          <div className="max-w-xl lg:max-w-3xl">
            <h1 className="mt-6 text-2xl font-bold text-gray-900 sm:text-2xl text-center">特定商取引法に基づく表記</h1>

            <div className="mt-6 space-y-6">
              <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-sm text-blue-900">
                  <strong>重要：</strong>本表記は、JOYBASEプラットフォームサービスの提供に関するものです。
                  各店舗が販売する商品（オリパ等）については、各店舗が独自に特定商取引法に基づく表記を行う義務があります。
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">事業者名</h2>
                <p className="mt-2 text-sm text-gray-700">合同会社Codingholic</p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">代表者</h2>
                <p className="mt-2 text-sm text-gray-700">岩元雄太郎</p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">所在地</h2>
                <p className="mt-2 text-sm text-gray-700">〒220-0072 神奈川県横浜市西区浅間町1丁目4番3号 ウィザードビル402</p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">連絡先</h2>
                <p className="mt-2 text-sm text-gray-700">
                  メールアドレス：support@joybase.jp<br />
                  電話番号：請求があり次第、遅滞なく開示いたします
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">販売価格（サービス利用料）</h2>
                <p className="mt-2 text-sm text-gray-700">
                  ポイント購入価格は、各店舗が定める価格にて引き渡します。<br />
                  購入単位や価格設定は店舗ごとに異なります。<br />
                  詳細な価格は、各店舗のポイント購入ページにてご確認ください。
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">商品代金以外の必要料金</h2>
                <p className="mt-2 text-sm text-gray-700">
                  ・クレジットカード決済手数料：購入者負担なし（店舗オーナー負担）<br />
                  ・システム利用料：購入者負担なし（店舗オーナー負担）<br />
                  ・当選商品の配送料：各店舗の設定により異なります（各イベントページをご確認ください）
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">支払方法</h2>
                <p className="mt-2 text-sm text-gray-700">クレジットカード決済（Visa、Mastercard、American Express、JCB等）</p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">支払時期</h2>
                <p className="mt-2 text-sm text-gray-700">
                  ポイント購入時に即時決済されます。<br />
                  ご利用のクレジットカード会社の規定に基づき請求されます。
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">商品・役務の引渡時期（サービス提供時期）</h2>
                <p className="mt-2 text-sm text-gray-700">
                  <strong>【ポイント付与】</strong><br />
                  決済完了後、即座にお客様のアカウントに付与されます。<br />
                  <br />
                  <strong>【抽選サービス】</strong><br />
                  イベント参加（抽選実行）後、即座に結果を確認いただけます。<br />
                  抽選結果はマイページの「抽選履歴」からいつでも確認可能です。<br />
                  <br />
                  <strong>【当選商品の発送】</strong><br />
                  当選商品の発送時期は、各店舗が設定する配送ポリシーに従います。<br />
                  標準的な発送期間：当選確定後7日～14日以内に発送<br />
                  （詳細な発送時期は各イベントページの「配送について」をご確認ください）<br />
                  <br />
                  ※配送状況の確認：発送後、マイページから配送状況を確認いただけます<br />
                  ※発送遅延：店舗都合で標準期間を超える場合は、店舗から個別にご連絡いたします
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">返品・キャンセル・返金について</h2>
                <p className="mt-2 text-sm text-gray-700">
                  <strong>【ポイント購入】</strong><br />
                  デジタルコンテンツの性質上、購入後のポイントの返金・キャンセルには応じられません。<br />
                  <br />
                  <strong>【抽選参加後】</strong><br />
                  抽選実行後のキャンセル・返金には応じられません。<br />
                  抽選を実行する前に、イベント内容・必要ポイント数を十分にご確認ください。<br />
                  <br />
                  <strong>【当選商品】</strong><br />
                  商品に瑕疵（破損・汚損等）がある場合は、商品到着後7日以内に各店舗へご連絡ください。<br />
                  店舗の判断により、交換または返金対応いたします。
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">特別な販売条件</h2>
                <p className="mt-2 text-sm text-gray-700">
                  ・サービス利用には会員登録（無料）が必要です<br />
                  ・18歳未満の方はサービスをご利用いただけません<br />
                  ・各イベントには参加条件や数量制限が設定されている場合があります
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">動作環境</h2>
                <p className="mt-2 text-sm text-gray-700">
                  最新版のChrome、Safari、Firefox、Edgeブラウザを推奨<br />
                  JavaScript及びCookieが有効である必要があります
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">販売業者と購入者の間の紛争について</h2>
                <p className="mt-2 text-sm text-gray-700">
                  各店舗が販売する商品に関する紛争（商品の品質、配送トラブル等）については、
                  購入者と販売店舗間で解決していただく必要があります。<br />
                  当社（合同会社Codingholic）はプラットフォーム提供者として、紛争解決のサポートを行いますが、
                  直接の販売責任は負いません。
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">免責事項</h2>
                <p className="mt-2 text-sm text-gray-700">
                  本サービスの利用において生じた損害について、当社は一切の責任を負いません。<br />
                  ただし、当社の故意または重大な過失による場合はこの限りではありません。<br />
                  また、消費者契約法その他の強行法規の適用により、本免責条項の一部が無効とされる場合は、
                  当該無効部分を除く部分について適用されるものとします。
                </p>
              </div>

              <div>
                <h2 className="text-base font-semibold text-gray-900">準拠法・管轄裁判所</h2>
                <p className="mt-2 text-sm text-gray-700">
                  本サービスに関する準拠法は日本法とします。<br />
                  本サービスに関して生じた紛争については、当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。
                </p>
              </div>

              {/* 改定履歴 */}
              <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                <h2 className="text-base font-semibold text-gray-900">改定履歴</h2>
                <ul className="mt-4 text-sm text-gray-700 space-y-1">
                  <li>2025/12/14 - 表記内容を整理</li>
                  <li>2025/12/12 - サービス提供時期の詳細を追加</li>
                  <li>2025/10/20 - 初版制定</li>
                </ul>
              </div>

              <p className="text-sm text-gray-500 text-right mt-8">
                制定日：2025年10月20日<br />
                最終改定日：2025年12月14日
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default TradeLawPage;
